/* EDIT SOFTSKILL ABILITY */
export const EDIT_SOFTSKILL_ABILITY_USER_POSITION =
  "EDIT_SOFTSKILL_ABILITY_USER_POSITION"
export const EDIT_SOFTSKILL_ABILITY_USER_POSITION_SUCCESS =
  "EDIT_SOFTSKILL_ABILITY_USER_POSITION_SUCCESS"
export const EDIT_SOFTSKILL_ABILITY_USER_POSITION_CLEAN =
  "EDIT_SOFTSKILL_ABILITY_USER_POSITION_CLEAN"
export const EDIT_SOFTSKILL_ABILITY_USER_POSITION_ERROR =
  "EDIT_SOFTSKILL_ABILITY_USER_POSITION_ERROR"
